// src/config.js
const applicationMode = "live";
var appName = "KOH Admin Panel";

//local
/*
var apiUrl = "http://localhost/tkp-club/";
var logo = "http://localhost/tkp-club/uploads/logo/logo.png";
var imageBasePath = "http://localhost/tkp-club/uploads";
*/

//server
var apiUrl = "https://api.kohpicnic.com/";
var logo = "https://api.kohpicnic.com/uploads/logo/logo.png";
var imageBasePath = "https://api.kohpicnic.com/uploads";


var pageSize = 10;

if (applicationMode === 'development') {
  appName = "KOH Admin Panel";
  //local
  //apiUrl = "http://localhost/tkp-club/";

  //server
  apiUrl = "https://api.kohpicnic.com/";
}
const config = {
  appName: appName,
  apiUrl: apiUrl,
  pageSize: pageSize,
  logo: logo,
   imageBasePath: imageBasePath,
};
export default config;